import TextComponent from './TextComponent'
export default TextComponent
